// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__SMO1M","content":"styles_content__1ov5Z","checkbox":"styles_checkbox__3OGQA","checkboxLabel":"styles_checkboxLabel__2Pvrp"};